module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-input",
    class: {
      active: _vm.custom
    },
    on: {
      "click": _vm.changeValue
    }
  }, [_c('div', {
    staticClass: "button"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ebd6f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/toggle-input.vue
// module id = 636
// module chunks = 1